<template>
  <div class="rl-sr">
    <div class="rl-sr-content">
      <div v-if="list && list.length" class="rl-sr-content-list">
        <div v-for="(item, index) in list" :key="index" class="rl-sr-content-list-item flex-row-center">
          <div class="rl-sr-content-list-item-cate cursor flex-shrink flex-center" @click="toCate(item)">
            <p>{{ item.catalogName }}</p>
          </div>
          <div class="rl-sr-content-list-item-name cursor flex-1" @click="toSource(item)">
            <p class="text-line-1">{{ item. title }}</p>
          </div>
          <div class="rl-sr-content-list-item-date flex-shrink">
            <p class="text-line-1">{{ handleDate(item.createTime) }}</p>
          </div>
        </div>
      </div>
      <div class="rl-sr-content-pages flex-center">
        <el-pagination
          background
          :page-size="10"
          layout="prev, pager, next"
          :total="total"
          @current-change="pageChage"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: null
    }
  },
  methods: {
    pageChage(v) {
      this.$emit('pageChange', v)
    },
    toSource(v) {
      this.$emit('link', v)
    },
    toCate(v) {
      this.$emit('linkcate', v)
    },
    handleDate(v) {
      return v.split(' ')[0]
    }
  }
}
</script>

<style scoped>
  .rl-sr-content-list-item {
    height: 30px;
    margin-bottom: 10px;
  }

  .rl-sr-content-list-item:last-child {
    margin-bottom: 0;
  }

  .rl-sr-content-list-item-cate {
    width: 58px;
    height: 20px;
    border-radius: 3px;
    background: #B20000;
    margin-right: 10px;
  }

  .rl-sr-content-list-item-cate p {
    color: #fff;
    font-size: 12px;
  }

  .rl-sr-content-list-item-name {
    margin-right: 15px;
  }

  .rl-sr-content-list-item-name p {
    color: #1A1A1A;
    font-size: 14px;
  }

  .rl-sr-content-list-item-date p {
    color: #999999;
    font-size: 12px;
  }

  .rl-sr-content-pages {
    margin-top: 60px;
  }

</style>

<style lang="scss" scoped>
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>
